export default __webpack_public_path__ + "static/media/sd-log-2.ea6d849b.jpg";